export var Departments = /*#__PURE__*/ function(Departments) {
    Departments["GROUP_LEADER"] = "group-leader";
    Departments["EMERITUS"] = "emeritus";
    Departments["CLINICAL_INVESTIGATORS"] = "clinical-investigators";
    Departments["SENIOR_INVESTIGATORS"] = "senior-investigators";
    Departments["GUEST_INVESTIGATORS"] = "guest-investigators";
    Departments["POSTDOCTORAL_SCIENTISTS"] = "postdoctoral-scientists";
    Departments["PHD_STUDENTS"] = "ph-d-students";
    Departments["RESEARCH_ASSISTANTS"] = "research-assistants";
    Departments["TECHNICAL_SUPPORT"] = "technical-support";
    Departments["ADMINISTRATIVE_SUPPORT"] = "administrative-support";
    Departments["MASTER_STUDENTS"] = "master-students";
    return Departments;
}({});

//# sourceMappingURL=Departments.js.map